module.exports = __webpack_public_path__ + "img/18.7e54007f.png";